<template>
  <div v-loading="loading" class="dwPzvipBody">
    <div class="_title">
      <p class="_title_info">系统变更出入库数据</p>
    </div>
    <el-form
      ref="searchForm"
      :rules="rules"
      :model="searchForm"
      label-position="right"
      class="_jbxxForm"
      label-width="200px"
    >
      <el-form-item label="单位名称：" prop="dwmc">
        <el-input v-model="searchForm.dwmc" placeholder="请输入完整的单位名称"/>
      </el-form-item>
      <el-form-item label="出入库类型：" prop="crkYwlx">
        <el-select v-model="searchForm.crkYwlx" placeholder="请选择出入库类型" style="width: 100%">
          <el-option
            v-for="(item, index) in crkYwlxList"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="出入库编号：" prop="crkBh">
        <el-input v-model="searchForm.crkBh" placeholder="请输入完整的出入库编号"/>
      </el-form-item>
      <div class="buttonList">
        <el-button @click="reset"> 重 置 </el-button>
        <el-button type="primary" @click="submit"> 搜 索 </el-button>
      </div>
    </el-form>

    <el-dialog v-loading="loading" title="修改出入库数据" :visible.sync="updFlag">
      <el-form ref="upddto" :model="upddto" label-width="150px">
        <el-form-item label="单位名称：">
          <el-input v-model="upddto.dwmc" disabled/>
        </el-form-item>
        <el-form-item label="出入库类型：">
          <el-input v-model="upddto.crkYwlxLabel" disabled/>
        </el-form-item>
        <el-form-item label="出入库编号：" >
          <el-input v-model="upddto.crkBh" disabled/>
        </el-form-item>
        <el-form-item label="化学品：" >
          <el-input v-model="upddto.hxpMc" disabled/>
        </el-form-item>
        <!--除移库报备、退货出库、内部退回和运输报备不选择这个仓库外，其余都需要选择-->
        <el-form-item label="存放仓库:" prop="ckId" v-if="upddto.crkYwlx != '106' && upddto.crkYwlx != '110' && upddto.crkYwlx != '121' && upddto.crkYwlx != '125'"
                      :rules="{
              required: true,
              trigger: ['blur', 'change'],
            }">
          <el-select
            style="width: 100%;"
            v-model="upddto.ckId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in dwckList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <!--移库报备才有-->
        <el-form-item label="移库前仓库:" prop="yrckId" v-if="upddto.crkYwlx == '106'"
                      :rules="{
              required: true,
              trigger: ['blur', 'change'],
            }">
          <el-select
            v-model="upddto.yrckId"
            placeholder="请选择"
            style="width: 100%;"
          >
            <el-option
              v-for="item in dwckList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="移库后仓库:" prop="ycckId" v-if="upddto.crkYwlx == '106'"
                      :rules="{
              required: true,
              trigger: ['blur', 'change'],
            }">
          <el-select
            v-model="upddto.ycckId"
            placeholder="请选择"
            style="width: 100%;"
          >
            <el-option
              v-for="item in dwckList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <!--购买入库和运输报备才有-->
        <el-form-item label="起运数量:" prop="qysl" v-if="upddto.crkYwlx == '101' || upddto.crkYwlx == '125'"
                      :rules="{
              required: true,
              validator:qyslValid,
              trigger: ['blur', 'change'],
            }">
          <div style="width: 100%;">
            <el-input
              v-model="upddto.qysl"
              placeholder="请输入"
              style="width: 600px; margin-right: 5px"
            />
            <el-select
              v-model="upddto.qyslDw"
              style="width: calc(100% - 600px - 5px)"
              placeholder="单位"
            >
              <el-option
                v-for="item in sldwList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="出入库数量:" prop="crkSl"
                      :rules="{
              required: true,
              validator:crkSlValid,
              trigger: ['blur', 'change'],
            }">
          <div style="width: 100%">
            <el-input
              v-model="upddto.crkSl"
              placeholder="请输入"
              style="width: 600px; margin-right: 5px"
            />
            <el-select
              v-model="upddto.crkSlDw"
              style="width: calc(100% - 600px - 5px)"
              placeholder="单位"
            >
              <el-option
                v-for="item in sldwList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="出入库日期:" prop="rq"
                      :rules="{
              required: true,
              trigger: ['blur', 'change'],
            }">
          <el-date-picker
            v-model="upddto.rq"
            :picker-options="pickerBeginDateBefore"
            type="date"
            style="width: 100%"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item
          label="变更理由:"
          prop="bgly"
          :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 1000);
              },
              trigger: ['blur', 'change'],
            }"
        >
          <el-input
            v-model="upddto.bgly"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updFlag = false">取 消</el-button>
        <el-button type="primary" @click="updSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { lengthValidate } from '@/assets/js/validate'
import { getSysCrkBgjlXgxx,saveSysCrkBgjl } from '@/assets/js/system.js'
export default {
  name: 'DwpzVip',
  data() {
    return {
      // 日期限制
      pickerBeginDateBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      loading: false,
      updFlag: false,
      rules: {
        dwmc: [{ message:'单位名称必填',required: true,trigger: ['blur', 'change'] }],
        crkBh: [{ message:'出入库编号必填',required: true,trigger: ['blur', 'change'] }],
        crkYwlx: [{ message:'出入库类型必选',required: true,trigger: ['blur', 'change'] }],
      },
      crkYwlxList: [
        {
          label: '生产入库变更',
          value: '100'
        },
        {
          label: '购买入库变更',
          value: '101'
        },
        {
          label: '其他入库变更',
          value: '102'
        },
        {
          label: '使用出库变更',
          value: '103'
        },
        {
          label: '销售出库变更',
          value: '104'
        },
        {
          label: '其他出库变更',
          value: '105'
        },
        {
          label: '移库报备变更',
          value: '106'
        },
        {
          label: '增溢入库变更',
          value: '107'
        },
        {
          label: '损耗出库变更',
          value: '108'
        },
        {
          label: '退货入库变更',
          value: '109'
        },
        {
          label: '退货出库变更',
          value: '110'
        },
        {
          label: '内部使用退回变更',
          value: '121'
        },
        {
          label: '运输报备变更',
          value: '125'
        }
      ],
      searchForm: {
        dwmc: '',
        crkBh: '',
        crkYwlx: ''
      },
      upddto: {
        crkYwlxLabel: '', //仅显示
        dwmc: '',
        crkBh: '',
        crkYwlx: '',
        crkSl: 0,
        crkSlDw: '',
        rq: '',
        ckId: '',
        bgly: '',
        qysl: 0,
        qyslDw: '',
        yrckId: '',
        ycckId: ''
      },
      vipList:[],
      sldwList:[],
      dwckList:[],
      localData: false,
      labelStyle:{'width' : '200px'},
      pickerBeginDateAfter: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        }
      },
    }
  },
  mounted(){
  },
  methods: {
    crkSlValid (rule, value, callback){
      if (!(this.upddto.crkSl + '')) {
        callback(new Error('请填写入库数量值'))
      }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!reg.test(this.upddto.crkSl)) {
        callback(new Error('请输入大于或等于0的数量值'))
      } else if (
        /^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value) == false
      ) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      } else if (!this.upddto.crkSlDw) {
        callback(new Error('请选择单位'))
      } else {
        callback()
      }
    },
    qyslValid (rule, value, callback){
      if (!(this.upddto.qysl + '')) {
        return callback(new Error('请填写起运数量'))
      }
      const reg = /^(0|[1-9][0-9]*)(\.\d+)?$/
      if (!reg.test(this.upddto.qysl)) {
        callback(new Error('请输入大于或等于0的数量值'))
      } else if (
        /^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value) == false
      ) {
        return callback(new Error('整数位最大长度9位,保留3位小数'))
      }else if (!this.upddto.qyslDw) {
        callback(new Error('请选择单位'))
      }
      callback()
    },
    lengthValidate,
    reset() {
      this.searchForm = { dwmc: '',crkBh: '', crkYwlx: '' }
      this.localData = false
    },
    submit() {
      this.$refs['searchForm'].validate((valid) => {
        if (valid) {
          getSysCrkBgjlXgxx(this.searchForm).then((e) => {
            this.updFlag = !this.updFlag
            this.upddto = e.data.data
            this.sldwList = e.data.data.sldwList
            this.dwckList = e.data.data.dwckList
          })
        }
      })
    },
    updSave(){
      this.$refs['upddto'].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将修改出入库数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            saveSysCrkBgjl(this.upddto).then((e) => {
              this.$message.success('修改成功')
              this.loading = false
              this.updFlag = !this.updFlag
            }).catch(() => {
              this.loading = false
            })
          })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.dwPzvipBody {
  padding: 20px;
  background-color: white;
  margin: 10px;
  height: calc(100% - 20px);
  ._title {
    margin-top: 50px;
    width: 100%;
    ._title_info {
      text-align: center;
      font-size: 23px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 32px;
      height: 32px;
      font-family: Helvetica;
    }
  }
  ._jbxxForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 100px auto 0px auto;
    width: 50%;

    .el-form-item {
      margin-right: 0;
      width: 100%;
      /deep/.el-form-item__content {
        display: flex !important;
      }
    }
  }
  .buttonList {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 20px auto 0px auto;
    width: 50%;
  }
}
.descriptions {
    width: 70%;
    margin: 0 auto;;
}
</style>
